"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._InventoryFilter = {
    type: "structure",
    required: ["Prefix"],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_InventoryFilter.js.map